import { call, select, take } from 'redux-saga/effects';
import { getScribeById } from 'JS/sagas/selectors';
import getScribeLengthMs from 'JS/playback/lib/Playback/helpers/getScribeLengthMs';
import getFileTypeFromFormat from 'JS/shared/helpers/getFileTypeFromFormat';
import {
  RENDER_FAILED,
  GET_VIDEO_DOWNLOAD_URL_SUCCESS,
  GET_VIDEO_DOWNLOAD_URL_FAILED,
  DOWNLOAD_REQUEST_FAILED
} from 'JS/actionCreators/downloadActions';
import { HIDE_MODAL } from 'JS/actionCreators/uiActions';

import { track, incrementUserProperties, incrementEventSuperProperty } from '../mixpanelProvider';

export default function* trackDownloadRequests({ scribeId, format }) {
  const scribe = yield select(state => getScribeById(state, scribeId));
  const numberOfElements = scribe.elements?.length || 0;
  const numberOfScenes = scribe.scenes?.length || 0;
  const scribeLengthSeconds = getScribeLengthMs(scribe) / 1000;
  const fileType = getFileTypeFromFormat(format);
  const { source } = scribe;
  let templateProperties = {};

  if (source?.type === 'template') {
    templateProperties['Scribe Template ID'] = source.meta?.templateId;
    templateProperties['Scribe Template Title'] = source.meta?.title;
  }

  const eventProperties = {
    'Scribe ID': scribeId,
    'File Type': fileType,
    'Scribe Length': scribeLengthSeconds,
    'Number of Scenes': numberOfScenes,
    'Number of Elements': numberOfElements,
    'Scribe Type': source?.type || 'unknown',
    ...templateProperties
  };

  yield call(track, 'Start Download', eventProperties);
  yield call(incrementUserProperties, 'Scribe Downloads Started');
  const result = yield take([
    HIDE_MODAL,
    GET_VIDEO_DOWNLOAD_URL_SUCCESS,
    RENDER_FAILED,
    GET_VIDEO_DOWNLOAD_URL_FAILED,
    DOWNLOAD_REQUEST_FAILED
  ]);

  if (result.type === GET_VIDEO_DOWNLOAD_URL_SUCCESS) {
    yield call(track, 'Download Succeeded', eventProperties);
    yield call(incrementUserProperties, 'Scribe Downloads Succeeded');
    yield call(incrementEventSuperProperty, 'Scribe Downloads Succeeded');
  } else if (result.type === HIDE_MODAL) {
    yield call(track, 'Abort Download', eventProperties);
    yield call(incrementUserProperties, 'Scribe Downloads Aborted');
  } else {
    yield call(track, 'Download Failed', eventProperties);
    yield call(incrementUserProperties, 'Scribe Downloads Failed');
  }
}
